module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_7.910fea28.webp";